import { render, staticRenderFns } from "./EquipPointComponent.vue?vue&type=template&id=de5ee8ac"
import script from "./EquipPointComponent.vue?vue&type=script&lang=js"
export * from "./EquipPointComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports